import type { FaireProductEntity } from "../../entity_types/product";

export const p_dahj7tn45p: FaireProductEntity = {
  token: "p_dahj7tn45p",
  type: "product",
  name: "First Words with Cute Embroidered Friends",
  brandToken: "b_x27fkb4h4a",
  brandName: "Paige Tate & Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/f925cdd78a31672907ae93809ee794fb44fe33890b63539bc40b67056970c3c5.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/77b3783fb2746ce11da7cd6aed4cf354c624ade869640515a5075c841da2d646.jpeg",
    "https://cdn.faire.com/fastly/6085266a068092fb77a9cae516529479680e6bf2ddbf5f9258fc3f4bebb27c8a.jpeg",
    "https://cdn.faire.com/fastly/113c873c160b1154816f683f89f8ad270913b28902c79ea3d39054f2357371ca.jpeg",
    "https://cdn.faire.com/fastly/199ae32cdb68e20f79a77fa30451680a6c762c667b1516a7347cf0d305010386.jpeg",
    "https://cdn.faire.com/fastly/9ae4b4f5453104fd61c296b4b63fa2afb228f6133d658dcb8e9f82664b2bd8d5.jpeg",
    "https://cdn.faire.com/fastly/9212d7e27831b7aa7c54c7a7ff90596af2dbeeb0d478e480d0d7db242721c963.jpeg",
  ],
  priceDollars: 6.81,
  description:
    "This book features bright and cute pictures that children will love looking at for hours, and its padded cover is sturdy and the perfect size for a child's small hands, so it won't dissolve in their mouths.\n\n• Features first words across charming themes like animals, toys, nature & more\n• Durable padded board book—perfectly sized for small hands\n• Part of a bestselling crafty series (crochet, quilted, and embroidered editions)\n\nCategories: giftables, baby shower, early reader books, early years,  embroidered,  educational, kids books, Faire Market 2026, first word book, first words, best baby gifts,  \n",
  tags: [],
  msrpDollars: 13.63,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:41.895Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
